<template>
  <div v-if="checkinsData">
    <h2 class="h3 m-0 mb-3 font-weight-semi-bold color-dark">Moments per category</h2>

    <VueSlimTable
      ref="table"
      :source="tableSource"
      :columns="columns"
      class="responsive-table borderless-table m-0">
      <template #row="{ row }">
        <CheckinsCategoriesRow :row="row" />
      </template>
    </VueSlimTable>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CheckinsCategoriesRow from './checkins_categories_row'
import { totalReviewsProps, mapIcons, hasPropertisData } from './helpers'

export default {
  components: { CheckinsCategoriesRow },
  created() {
    this.mapIcons = mapIcons
    this.totalReviewsProps = totalReviewsProps
    this.columns = [
      { key: 'category', title: 'Category' },
      { key: 'data', title: 'Moments' }
    ]
  },
  computed: mapState(['chosenLocation', 'checkinsData', 'parsedData']),
  methods: {
    hasPropertisData,
    tableSource() {
      const checkinsData = this.chosenLocation ? this.checkinsData.byLocations[this.chosenLocation.id] : this.checkinsData.aggregated
      return checkinsData ? checkinsData.categories : []
    }
  }
}
</script>
